import Alert from './alert/alert';
import Body from './body/body';
import Footer from './footer/footer';
import Header from './header/header';

export type {ModalManagerRefObject} from '../modal-manager';

type AlertBundleT = typeof Alert & {
	Header: typeof Header;
	Body: typeof Body;
	Footer: typeof Footer;
}

const AlertBundle: AlertBundleT = Alert as unknown as AlertBundleT;

AlertBundle.Header = Header;
AlertBundle.Body = Body;
AlertBundle.Footer = Footer;

export {AlertBundle as Alert};
